export default __webpack_public_path__ + "static/media/Visual 12.ed97ea2d.jpeg";